import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectDVCPMATrackingForecastLocationId,
  selectDVCPMATrackingForecastMultiLocationIds,
  selectDVCPMATrackingForecastSubpage,
  selectDVCPMATrackingForecastTimeFrequency,
  selectDVCPMATrackingForecastVariable,
} from 'redux/reducers/meteorologyAgroTrackingForecastDetailedViewControlPanelReducer';
import {
  useLazyGetAgroTrackingForecastDetailedViewDatesQuery,
} from 'services/api/Meteorology/Agro/TrackingForecast/DetailedView';
import { SUBPAGE_SUBMENU_OPTIONS } from 'types/Meteorology/Agro/TrackingForecast/DetailedView';

export default function useForecastDateOptions() {
  const subpage = useSelector(selectDVCPMATrackingForecastSubpage);
  const submenu = SUBPAGE_SUBMENU_OPTIONS[subpage];
  const timeFrequency = useSelector(selectDVCPMATrackingForecastTimeFrequency);
  const locationId = useSelector(selectDVCPMATrackingForecastLocationId);
  const locationIds = useSelector(selectDVCPMATrackingForecastMultiLocationIds);
  const variable = useSelector(selectDVCPMATrackingForecastVariable);

  const [trigger, {
    data, isFetching,
  }] = useLazyGetAgroTrackingForecastDetailedViewDatesQuery();

  const defaultFields = useMemo(() => (
    Boolean(timeFrequency && variable)
  ), [timeFrequency, variable]);
  const singleLocationFields = useMemo(() => (
    Boolean(timeFrequency && locationId)
  ), [timeFrequency, locationId]);
  const multiLocationFields = useMemo(() => (
    Boolean(defaultFields && locationIds.length > 0)
  ), [defaultFields, locationIds]);
  const multiRoundFields = useMemo(() => (
    Boolean(defaultFields && singleLocationFields)
  ), [defaultFields, singleLocationFields]);

  const dates = useMemo(() => {
    if (!data) return [];

    switch (submenu) {
      case 'multi-locais': return multiLocationFields ? data : [];
      case 'multi-rodadas': return multiRoundFields ? data : [];
      default: return [];
    }
  }, [data, submenu, multiLocationFields, multiRoundFields]);

  useEffect(() => {
    switch (submenu) {
      case 'multi-locais':
        if (multiLocationFields) {
          trigger({
            submenu,
            timeFrequency,
            variable,
            locationIds,
          });
        }
        break;
      case 'multi-rodadas':
        if (multiRoundFields) {
          trigger({
            submenu,
            locationId,
            timeFrequency,
            variable,
          });
        }
        break;
      default: break;
    }
  }, [
    submenu, multiLocationFields, multiRoundFields,
    locationId, timeFrequency, variable, locationIds, trigger,
  ]);

  return { dates, isFetching };
}
